const DEFAULT_TRUSTED_HOSTS = ['hubspot.com'];
const DEFAULT_ALLOWED_PROTOCOLS = ['http', 'https', 'data'];
export const sanitizeImageSrc = (src, config = {}) => {
  if (!src || typeof src !== 'string') {
    return null;
  }
  const {
    trustedHosts = DEFAULT_TRUSTED_HOSTS,
    allowedProtocols = DEFAULT_ALLOWED_PROTOCOLS
  } = config;
  try {
    if (src.startsWith('data:')) {
      if (allowedProtocols.includes('data')) {
        const dataUrlPattern = /^data:image\/(jpeg|jpg|png|gif|webp|svg\+xml);base64,/i;
        return dataUrlPattern.test(src) ? src : null;
      }
      return null;
    }
    if (src.startsWith('/') || src.startsWith('./') || src.startsWith('../')) {
      return src;
    }
    let url;
    let correctedSrc = src;
    try {
      url = new URL(src);
    } catch (_unused) {
      // Try to prepend https:// for URLs that might be missing protocol
      if (!src.includes('://') &&
      // eslint-disable-next-line no-script-url
      !src.startsWith('javascript:') && !src.startsWith('data:')) {
        try {
          correctedSrc = `https://${src}`;
          url = new URL(correctedSrc);
        } catch (_unused2) {
          return null;
        }
      } else {
        return null;
      }
    }
    const protocol = url.protocol.slice(0, -1);
    if (!allowedProtocols.includes(protocol)) {
      return null;
    }
    const hostname = url.hostname.toLowerCase();
    const isTrustedHost = trustedHosts.some(trustedHost => {
      const normalizedTrustedHost = trustedHost.toLowerCase();
      return hostname === normalizedTrustedHost || hostname.endsWith(`.${normalizedTrustedHost}`);
    });
    if (!isTrustedHost) {
      return null;
    }
    return correctedSrc;
  } catch (error) {
    return null;
  }
};
export const createImageSrcSanitizer = (config = {}) => {
  return src => {
    return sanitizeImageSrc(src, config);
  };
};